import { _GLOBALS } from '../globals.js';
import { TOKEN_PROGRAM_ID, TOKEN_2022_PROGRAM_ID} from "@solana/spl-token";
import { Connection } from "@solana/web3.js";

import { tokenDetailsRegistry } from "./tokenMeta/legacy.js";
import { tokenDetailsMetaplex } from "./tokenMeta/metaplex.js";
import { tokenDetails2022 } from "./tokenMeta/2022.js";

const alt_rpc_endpoint = _GLOBALS.SolanaRpc;
let alt_connection = null;

async function processTokenAccounts(connection, tokenAccounts) {
    let accounts = [];
    for (const [i, account] of tokenAccounts.entries()) {
        const parsedAccountInfo = account.account.data;
        const mintAddress = parsedAccountInfo?.parsed?.info?.mint;
        const tokenBalanceUI = parsedAccountInfo?.parsed?.info?.tokenAmount?.uiAmountString;
        const tokenBalance = parsedAccountInfo?.parsed?.info?.tokenAmount?.amount;

        if (mintAddress) {
            try {
                const details = await tokenDetailsRegistry(mintAddress) || 
                await tokenDetailsMetaplex(connection, mintAddress) || 
                await tokenDetails2022(connection, mintAddress);
        
                if(mintAddress === "4zMMC9srt5Ri5X14GAgXhaHii3GnPAEERYPJgZJDncDU") 
                {
                    accounts.push({ 
                        mint : mintAddress,
                        account : account.pubkey.toString(),
                        amount : parseInt(tokenBalance),
                        amountUi : tokenBalanceUI,
                        "logo": "https://raw.githubusercontent.com/solana-labs/token-list/main/assets/mainnet/EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v/logo.png",
                        "symbol": "USDC",
                        "name": "USD Coin (DEVNET)",
                        decimals: 6
                    });
                } else {
        
                    accounts.push({ 
                      mint : mintAddress,
                      account : account.pubkey.toString(),
                      amount : parseInt(tokenBalance),
                      amountUi : tokenBalanceUI,
                      ...details
                    });
                }
            } catch (error) {
                console.error(`Failed to fetch metadata for mint ${mintAddress}:`, error);
            }
        }
    }
    return accounts;
}

async function detectTokensBase(connection = null, publicKey, mints, programId, dataSize = null) {
  connection = connection ?? new Connection(alt_rpc_endpoint);

  const filters = [
    ...(dataSize ? [{ dataSize }] : []), // filter if account the size is fixed for legacy tokens
    {
      memcmp: {
        offset: 32, // owner field offset
        bytes: publicKey,
      },
    },
  ];

  const tokenAccounts = await connection.getParsedProgramAccounts(programId, { filters });
  const tokensFound =  await processTokenAccounts(connection, tokenAccounts);

  if (mints) {
    const foundTokens = tokensFound.filter(item => mints.includes(item.mint));
  
    // Create a set of found mint addresses for quick lookup
    const foundMints = new Set(foundTokens.map(item => item.mint));
  
    // Process mints that are not found in tokensFound
    const missingTokens = await Promise.all(
      mints
        .filter(mint => !foundMints.has(mint)) // Find mints that are missing
        .map(async mint => {
          const details = await tokenDetailsRegistry(mint) || 
                          await tokenDetailsMetaplex(connection, mint) || 
                          await tokenDetails2022(connection, mint);
                  
          return {
            mint,
            account: null,
            amount: 0,
            amountUi: "0",
            ...details
          };
        })
    );
  
    // Combine found tokens and the missing tokens
    return [...foundTokens, ...missingTokens];
  }
  
  return tokensFound;
}

export async function detectTokens(connection = null, publicKey, mints) {
  return detectTokensBase(connection, publicKey, mints, TOKEN_PROGRAM_ID, 165);
}

export async function detectTokens2022(connection = null, publicKey, mints) {
  return detectTokensBase(connection, publicKey, mints, TOKEN_2022_PROGRAM_ID);
}
